import colors from '../../config/colors.json'
import { Scatter } from 'react-chartjs-2';
import { useSocketEvent, useSocketState } from '../../helpers/useSocket';
import React, { useState } from 'react';

import villagerTest from '../../config/villagerTestJson.json'



const age2img = new Image(30, 30)
age2img.src = "/age_icons/age_2_dark.png"
const age3img = new Image(30, 30)
age3img.src = "/age_icons/age_3_dark.png"
const age4img = new Image(30, 30)
age4img.src = "/age_icons/age_4_dark.png"

const LiveGameEconomyChart = ({ leftColor, rightColor, height }) => {

  const [villagerTimeline, setVillagerTimeline] = useState([]);
  const [annotations, setAnnotations] = useState([]);

  useSocketEvent('updateEconomyGraph', (newdata) => {
    console.log(`Received updateConfig`, newdata);
    setVillagerTimeline(newdata)
  })

  useSocketEvent('updateAgeUpAnnotations', (newdata) => {
    console.log(`Received updateAgeUpAnnotations`, newdata);
    transformAnnotations(newdata)
  })

  function transformAnnotations(data) {
    let _annotations = []

    data?.forEach(element => {
      console.log(element)

      let img = element.newAge === 2 ? age2img : element.newAge === 3 ? age3img : age4img
      let index = element.playerID === "leftColor" ? 0 : 1
      let color = element.playerID === "leftColor" ? leftColor : rightColor

      _annotations.push({
        type: 'line',
        scaleID: 'x',
        value: element.tick,
        borderColor: colors[color]?.mainColor,
        borderWidth: 4,
        borderDash: [4, 4],
        label: {
          display: true,
          backgroundColor: 'rgba(0,0,0,0.1)',
          color: colors[color]?.mainColor,
          position: index ? '5%' : '20%',
          font: { size: 20 },
          padding: { left: 4, top: 4, right: 4, bottom: 2 },
          content: img
        }
      });
    });

    setAnnotations(_annotations)
  }

  console.log(annotations)

  let granularity = 45

  return (
    <div className="livegame__charts__economy border" style={{ height: height, borderColor: 'var(--main-color)', backgroundImage: 'url("/sheepCounter/background.png")' }}>
      <h1 className="text-center uppercase text-1xl text-white">Economy Count</h1>
      {villagerTimeline.length !== 0 &&
        <Scatter className=""

          height={height}

          style={{ maxHeight: height }}
          options={{
            maintainAspectRatio: false,
            aspectRatio: 1,
            animation: false,
            legend: {
              display: false
            },
            title: {
              display: false
            },
            scales: {
              x: {
                ticks: {
                  stepSize: 60,
                  callback: (v) => v >= 30 ? (parseInt((v / 8) / 60).toString() + " ") : '',
                  color: 'white',
                },
                grid: {
                  color: 'rgba(255,255,255,.1)'
                }
              },
              y: {
                beginAtZero: true,
                ticks: {
                  color: 'white',
                  font: { size: 12 }
                },
                grid: {
                  color: 'rgba(255,255,255,.1)'
                },
                afterFit: (axis) => { axis.width = Math.max(axis.width, 40); }
              }
            },
            plugins: {
              legend: {
                display: false
              },
              annotation: {
                annotations: annotations
              }
            }
          }}

          data={{
            datasets: [{
              label: '',
              type: 'line',
              data: villagerTimeline?.filter((el, i, arr) => i % granularity === 0 || i === arr.length - 1).map(v => ({ x: v.tick, y: v.leftValue })),
              //data: summary?.players[0].timeline.map(v => ({ x: v.time, y: v.population_economy })),
              borderColor: colors[leftColor]?.mainColor,
              borderWidth: 4,
              pointRadius: 0,
            },
            {
              label: '',
              type: 'line',
              data: villagerTimeline?.filter((el, i, arr) => i % granularity === 0 || i === arr.length - 1).map(v => ({ x: v.tick, y: v.leftValue + v.leftAltValue })),
              borderColor: colors[leftColor]?.secondaryColor,
              borderWidth: 4,
              pointRadius: 0,
              borderDash: [6, 6]
            },
            {
              label: '',
              type: 'line',
              data: villagerTimeline?.filter((el, i, arr) => i % granularity === 0 || i === arr.length - 1).map(v => ({ x: v.tick, y: v.rightValue })),
              //data: summary?.players[1].timeline.map(v => ({ x: v.time, y: v.population_economy })),
              borderColor: colors[rightColor].mainColor,
              borderWidth: 4,
              pointRadius: 0,
            },
            {
              label: '',
              type: 'line',
              data: villagerTimeline?.filter((el, i, arr) => i % granularity === 0 || i === arr.length - 1).map(v => ({ x: v.tick, y: v.rightValue + v.rightAltValue })),
              borderColor: colors[rightColor]?.secondaryColor,
              borderWidth: 4,
              pointRadius: 0,
              borderDash: [6, 6]
            },
            ]
          }}
        />
      }
    </div>
  )

}

export { LiveGameEconomyChart }
